export default function initSectionTabList() {
    const elements = document.querySelectorAll('.js-section-tab-list');

    elements.forEach((element) => {
        const tabButtons = element.querySelectorAll('.js-section-tab');
        const tabs = element.querySelectorAll('.js-section-tab-content');

        const changeTab = (tabTitle) => {
            tabButtons.forEach((tab) => tab.classList.remove('active'));
            tabs.forEach((tab) => tab.classList.remove('active'));

            const tabButton = element.querySelector(`.js-section-tab[data-tab="${tabTitle}"]`);
            if (tabButton) {
                tabButton.classList.add('active');
            }

            const tab = element.querySelector(`.${tabTitle.toLowerCase()}`);
            if (tab) {
                tab.classList.add('active');
            }
        };

        tabButtons.forEach((button) => {
            button.addEventListener('click', () => {
                changeTab(button.dataset.tab);
            });
        });

        setTimeout(() => {
            const mobileSelectField = element.querySelector('.js-section-tab-list-select .custom-select__items');
            if (!mobileSelectField) return;

            mobileSelectField.addEventListener('click', () => {
                const selectedOption = mobileSelectField.querySelector('.selected');
                changeTab(selectedOption.innerHTML);
            }, false);
        });
    });
}

window.addEventListener('load', initSectionTabList);
